import { PropsWithChildren } from "react"

export function Header({ children }: PropsWithChildren<{}>) {
  return (
    <div className="mb-20 mt-32 text-center text-7xl font-bold leading-tight">
      {children}
    </div>
  )
}
